import React from "react";
import Win11Logo from "../assets/images/win11-logo.webp";

function Splash() {
  return (
    <div
      className="d-flex align-items-center bg-white justify-content-center min-vh-100"
      
    >
      <div className="text-center px-3">

        {/* LOGO */}
        <div className="mb-4">
          <img
            src={Win11Logo}
            alt="WIN11 Logo"
            style={{
              width: "240px",
              maxWidth: "90%",
              objectFit: "contain",
              animation: "float 2.5s ease-in-out infinite",
              filter: "drop-shadow(0 8px 20px rgba(0,0,0,0.25))",
            }}
          />
        </div>

        {/* LOADER */}
        <div
          className="spinner-border text-danger"
          role="status"
          style={{ width: "2.8rem", height: "2.8rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>

        {/* TAGLINE */}
        
      </div>

      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
            100% { transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}

export default Splash;
